/**
 * E.164 for the accepted-job shop call link.
 *
 * Non-digits are stripped. A value that starts with `+1`, or any 11-digit
 * value that starts with 1, becomes `+1` plus the 10 national digits.
 * Any other 10-digit value becomes `+1` plus those digits.
 *
 * Empty or unrecognized input returns `''`. The modal omits the `tel` href
 * in that case (no link). The visible shop phone is left as stored.
 */
export function shopPhoneE164(phone: unknown): string {
    const raw = rawPhone(phone);
    if (!raw) return '';

    const digits = raw.replace(/\D/g, '');
    if (raw.startsWith('+1') || (digits.length === 11 && digits.startsWith('1'))) {
        const national = digits.startsWith('1') ? digits.slice(1) : '';
        return national.length === 10 ? `+1${national}` : '';
    }
    if (digits.length === 10) return `+1${digits}`;
    return '';
}

function rawPhone(phone: unknown): string {
    if (typeof phone === 'string') return phone.trim();
    if (typeof phone === 'number' && Number.isFinite(phone)) return String(Math.trunc(phone));
    return '';
}
